import React from 'react';
import ReactDOM from 'react-dom';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';
import Datetime from 'react-datetime';
import HelpComponent from './HelpComponent';

class AboutUs extends React.Component{
    constructor(){
        super();
        this.state ={
            isBubbleUIOpen : false,
            bubbleUI : {},
            element : {}
        };
    }
    aboutUs(){
        let isBubbleUIOpen = !this.state.isBubbleUIOpen;
        let UIthis = this;
        if(isBubbleUIOpen){
            let BBparameterBD = {};
            BBparameterBD.width = 600;
            BBparameterBD.height = 450;
            BBparameterBD.x = 120.298468
            BBparameterBD.y = 22.664729
            BBparameterBD.z = 6.04001092910767;
            BBparameterBD.lockPointHorizontal = "middle";
            BBparameterBD.lockPointVertical = "bottom";
            BBparameterBD.haveButton = true;
            let bubbleboxBD = new window.ov.UI.BubbleUI(BBparameterBD);                        
            let element = document.getElementById("bubblebox_div");
            if(element === null){
                element = this.state.element;
            }
            bubbleboxBD.appendContent(element);
            window.main.OView.UIContext.addUI(bubbleboxBD);
            let Pos = new window.Geo3DPoint(120.298098,22.665242,365.96);
            let V = new window.Geo3DPoint(0,0,-1);
            let Up = new window.Geo3DPoint(0,1,0);
            let Camera = new window.ov.Camera(Pos,V,Up);
            window.main.OView.gotoCamera(Camera, true);
            this.setState({isBubbleUIOpen:isBubbleUIOpen,bubbleUI:bubbleboxBD,element:element});
        }
        else{
            window.main.OView.UIContext.removeUI(this.state.bubbleUI);
            this.setState({isBubbleUIOpen:isBubbleUIOpen,bubbleUI:{}});
        }
    }
    render(){
        return(
            <div>
                <div className="ts card primary basic button" style={{margin: "10px 20px"}} onClick={(e)=>this.aboutUs()}>
                    <div className="content">
                        <h4 className="header">關於我們</h4>
                    </div>                    
                </div>
                <div id="bubblebox_div">
                    {
                        this.state.isBubbleUIOpen?
                        <div id="context">
                            <div id="bubblebox_img" style={{textAlign:"center"}}>
                                <img src="img/合設實驗室logo.png" style={{width:"480px",margin:"85px 0px 0px 0px"}}/>
                            </div> 
                            <div id="bubblebox_text" style={{margin:"52px 0px 0px 70px",fontSize:"18px"}}>
                                <div className="ts grid">
                                    <div className="ts six wide column">
                                        連絡電話：
                                    </div>
                                    <div className="ts ten wide column">
                                        <i className="fax icon"></i>07-5548288
                                    </div>
                                </div>
                                <div className="ts grid">
                                    <div className="ts six wide column">
                                        連絡地址：
                                    </div>
                                    <div className="ts ten wide column">
                                        <i className="marker icon"></i>高雄市鼓山區文信路262號6樓602室
                                    </div>
                                </div>
                                <div className="ts grid">
                                    <div className="ts six wide column">
                                        公司官網：
                                    </div>
                                    <div className="ts ten wide column">
                                        <i className="world icon"></i><a href="https://www.pilotgaea.com.tw" target="_blank">www.pilotgaea.com.tw</a>
                                    </div>
                                </div>
                            </div>
                        </div> : null
                    }
                </div>
            </div>
        );        
    }
}

class ContourLineSetting extends React.Component{
    constructor(){
        super();
        this.state = {
            contourLine:false,
            interval:100,
            displayColorPicker: false,
            color: {
              r: '255',
              g: '255',
              b: '255',
              a: '1',
            },
            hexColor:"#FFFFFF",
            helpMode : "None"
        }
    }    
    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };
    
    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };
    
    handleChange = (color) => {
        this.setContourLine(this.state.contourLine,this.state.interval,color.hex);
        this.setState({ color: color.rgb, hexColor:color.hex })        
    };
    setContourLine(contourLine,interval,color){
        const ContourLineThis = this;
        window.main.OView.drawTerrainSetting = {
            "contourSetting": {
                "isopen": contourLine,
                "color": new window.GLCOLOR(color),
                "interval": interval,
                "alpha": Number(ContourLineThis.state.color.a)
            }
        };
    }
    setContourLineOpen(){        
        this.setContourLine(!this.state.contourLine,this.state.interval,this.state.hexColor);
        this.setState({contourLine:!this.state.contourLine});
    }
    IntervalChange(event){
        this.setContourLine(this.state.contourLine,event.target.valueAsNumber,this.state.hexColor);
        this.setState({interval:event.target.valueAsNumber});
    }
    onHelpClick(mode){
        this.setState({helpMode:mode});
    }
    render(){
        const contourLine = this.state.contourLine;
        const styles = reactCSS({
            'default': {
                color: {
                    width: '125px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `rgba(${ this.state.color.r }, ${ this.state.color.g }, ${ this.state.color.b }, ${ this.state.color.a })`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '10px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '20000',
                    right: '0px'
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        switch(this.state.helpMode){
            case "ContourLine":
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/Toggw5Pif6k" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help')); 
                break;
            case "None":
                ReactDOM.unmountComponentAtNode(document.getElementById('Help'));
                break;
        }
        return(
            <div class="ts card" style={{margin:"10px 20px 10px 20px"}}>
                <div class="content">
                    <div class="header">等高線設定</div>
                    <div class="description">
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">
                                    開啟等高線：
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"8px"}} onClick={(e)=>this.onHelpClick("ContourLine")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </h6>
                            </div>
                            <div className="ts six wide column">                            
                                <div class="ts toggle checkbox">
                                    <input type="checkbox" id="ContourLine" checked={this.state.contourLine} onClick={(e)=>this.setContourLineOpen()}></input>
                                    <label for="ContourLine" ></label>
                                </div>                                        
                            </div>
                        </div>
                        {
                            contourLine?
                                <div className="ts card">
                                    <div className="content">
                                        <div className="ts grid">
                                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                                <h6 className="layerNameCSS">間距：</h6>
                                            </div>
                                            <div className="ts six wide column">                            
                                                <div class="ts mini circular input">
                                                    <input type="number" placeholder="間距" value={this.state.interval} style={{width:"100%"}} onChange={(e)=>this.IntervalChange(e)}></input>
                                                </div>                             
                                            </div>
                                        </div>
                                        <div className="ts grid">
                                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                                <h6 className="layerNameCSS">顏色：</h6>
                                            </div>
                                            <div className="ts six wide column">                            
                                                <div>
                                                    <div style={ styles.swatch } onClick={ this.handleClick }>
                                                        <div style={ styles.color } />
                                                        </div>
                                                        { 
                                                            this.state.displayColorPicker ? <div style={ styles.popover }>
                                                            <div style={ styles.cover } onClick={ this.handleClose }/>
                                                            <SketchPicker color={ this.state.color } onChange={ this.handleChange } />
                                                            </div> : null 
                                                        }
                                                </div>                                 
                                            </div>
                                        </div>                                        
                                    </div>                                    
                                </div> : null
                        }                        
                    </div>
                </div>
            </div>  
        );
    }
}

class LightSetting extends React.Component{
    constructor(){
        super();
        this.state = {
            lightRendering : true,
            lightScattering : false,            
            modelShadow : false,
            almanac : false,
            realTime : true,
            realTimeIntervalId : {},
            date : new Date(Date.now()),
            lightZenith : 45,
            lightAzimuth : 45,
            helpMode : "None"
        };
        this.realTimeInterva = this.realTimeInterva.bind(this);
    }
    setLightRenderingOpen(){
        window.main.OView.enableLight = !this.state.lightRendering;
        this.setState({lightRendering:!this.state.lightRendering});
    }
    setLightScatteringOpen(){
        window.main.OView.enableVolumetricLightScattering = !this.state.lightScattering;
        this.setState({lightScattering:!this.state.lightScattering});
    }
    setModelShadowOpen(){
        window.main.OView.enableShadow = !this.state.modelShadow;
        this.setState({modelShadow : !this.state.modelShadow});
    }
    setAlmanacOpen(){
        let LightProperty = window.main.OView.lightProperty;
        let realTimeIntervalId = this.state.realTimeIntervalId;
        clearInterval(realTimeIntervalId);        
        realTimeIntervalId = {};
        if(!this.state.almanac&&this.state.realTime){
            window.alertify.success("已將日照設定為現在時間");
            let date = new Date();
            window.main.OView.date = date;
            realTimeIntervalId = setInterval(this.realTimeInterva, 5000);
        }
        LightProperty.isAutoUpdateByDate =!this.state.almanac;
        LightProperty.isAbs =!this.state.almanac;
        window.main.OView.lightProperty = LightProperty;
        this.setState({almanac : !this.state.almanac ,realTimeIntervalId:realTimeIntervalId});
    }
    DatetimeChange(event){
        if(this.state.realTime){
            this.setState({date:this.state.date});
        }
        else{
            window.main.OView.date = event.toDate();
            this.setState({date:event.toDate()});
        }        
    }
    setLightAzimuth(event){
        let LightProperty = window.main.OView.lightProperty;
        LightProperty.azimuthAngle = event.target.valueAsNumber;
        window.main.OView.lightProperty = LightProperty;
        this.setState({lightAzimuth:event.target.valueAsNumber});
    }
    setLightZenith(event){
        let LightProperty = window.main.OView.lightProperty;
        LightProperty.zenithAngle = event.target.valueAsNumber;
        window.main.OView.lightProperty = LightProperty;
        this.setState({lightZenith:event.target.valueAsNumber});
    }
    lightMouseEnter(){
        let LightProperty = window.main.OView.lightProperty;
        window.main.OView.enableDrawLightDirectionSketchMap = true;
        if(LightProperty.azimuthAngle!==this.state.lightAzimuth || LightProperty.zenithAngle!==this.state.lightZenith)
            this.setState({lightAzimuth:LightProperty.azimuthAngle,lightZenith:LightProperty.zenithAngle});
    }
    lightMouseLeave(){
        window.main.OView.enableDrawLightDirectionSketchMap = false;
    }
    realTimeInterva(){
        let date = new Date();
        window.main.OView.date = date;
        this.setState({date:date});
    }
    isRealTimeOpen(){
        let realTime = !this.state.realTime;
        let realTimeIntervalId = this.state.realTimeIntervalId;
        if(this.state.realTime){     
            window.alertify.success("現在可以自行設定時間了");       
            clearInterval(realTimeIntervalId);
            realTimeIntervalId = {};
            this.setState({realTime:realTime,realTimeIntervalId:realTimeIntervalId});
        }
        else{
            window.alertify.success("已將日照設定為現在時間");
            let date = new Date();
            window.main.OView.date = date;
            realTimeIntervalId = setInterval(this.realTimeInterva, 5000);
            this.setState({realTime:realTime,realTimeIntervalId:realTimeIntervalId,date:date});
        }
        
    }
    onHelpClick(mode){        
        this.setState({helpMode:mode})
    }
    render(){
        const siderRangeCSS ={
            background: "linear-gradient(45deg, rgba(59,173,227,1) 0%, rgba(87,111,230,1) 25%, rgba(152,68,183,1) 51%, rgba(255,53,127,1) 100%)"
        };
        let isRealTime ;
        if(this.state.realTime){
            isRealTime = 
            <div>
                <Datetime value={this.state.date} input={false} inputProps={{disabled:true}} onChange={(e)=>this.DatetimeChange(e)} locale="zh-tw" lang="zh-tw"/>
                <div className="ts fluid vertical buttons">
                    <button className="ts warning button" onClick={(e)=>this.isRealTimeOpen()}>選擇自訂時間</button>
                </div>
            </div>;
        }
        else{
            isRealTime = 
            <div>
                <Datetime value={this.state.date} input={false} onChange={(e)=>this.DatetimeChange(e)} locale="zh-tw" lang="zh-tw"/>
                <div className="ts fluid vertical buttons">
                    <button className="ts primary button" onClick={(e)=>this.isRealTimeOpen()}>使用現在時間</button>
                </div>
            </div>;
        }        
        switch(this.state.helpMode){
            case "LightRenderingHelp":
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/m8ZtjiD3F_I" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help')); 
                break; 
            case "LightScatteringHelp":
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/RjGVRi2MzuQ" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
                break;
            case "ModelShadowHelp":
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/uchVcVhms10" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
                break;                         
            case "AlmanacHelp":
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/IVF8izHHiMg" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
                break;
            case "AzimuthHelp":
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/x24YHXPAwKQ" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help')); 
                break;
            case "None":
                ReactDOM.unmountComponentAtNode(document.getElementById('Help'));
                break;
        }
        return(
            <div className="ts card" style={{margin:"10px 20px 10px 20px"}}>
                <div className="content">
                    <div className="header">日光設定</div>
                    <div className="description">
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">日光渲染：
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"8px"}} onClick={(e)=>this.onHelpClick("LightRenderingHelp")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>                                    
                                </h6>
                            </div>
                            <div className="ts six wide column">                            
                                <div className="ts toggle checkbox">
                                    <input type="checkbox" id="LightRendering" checked={this.state.lightRendering} onClick={(e)=>this.setLightRenderingOpen()}></input>
                                    <label for="LightRendering" ></label>
                                </div>                                        
                            </div>
                        </div>
                        {
                            this.state.lightRendering?
                                <div className="ts card">
                                    <div className="content">
                                        <div className="ts grid">
                                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                                <h6 className="layerNameCSS">光線散射：
                                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"8px"}} onClick={(e)=>this.onHelpClick("LightScatteringHelp")}>
                                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                                    </button>
                                                </h6>
                                            </div>
                                            <div className="ts six wide column">                            
                                                <div className="ts toggle checkbox">
                                                    <input type="checkbox" id="LightScattering"  checked={this.state.lightScattering} onClick={(e)=>this.setLightScatteringOpen()}></input>
                                                    <label for="LightScattering" ></label>
                                                </div>                               
                                            </div>
                                        </div>
                                        <div className="ts grid">
                                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                                <h6 className="layerNameCSS">建物陰影：
                                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"8px"}} onClick={(e)=>this.onHelpClick("ModelShadowHelp")}>
                                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                                    </button>
                                                </h6>
                                            </div>
                                            <div className="ts six wide column">                            
                                                <div className="ts toggle checkbox">
                                                    <input type="checkbox" id="ModelShadow" checked={this.state.modelShadow} onClick={(e)=>this.setModelShadowOpen()}></input>
                                                    <label for="ModelShadow" ></label>
                                                </div>                              
                                            </div>
                                        </div>
                                        <div className="ts grid">
                                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                                <h6 className="layerNameCSS">天文曆：
                                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"8px"}} onClick={(e)=>this.onHelpClick("AlmanacHelp")}>
                                                            <i className="help small icon" style={{color:"#919191"}}></i>
                                                    </button>
                                                </h6>
                                            </div>
                                            <div className="ts six wide column">                            
                                                <div className="ts toggle checkbox">
                                                    <input type="checkbox" id="almanac" checked={this.state.almanac} onClick={(e)=>this.setAlmanacOpen()}></input>
                                                    <label for="almanac" ></label>
                                                </div>                              
                                            </div>
                                        </div>
                                        {
                                            this.state.almanac?
                                            isRealTime
                                            :
                                            <div>
                                                <div className="ts grid">
                                                    <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                                        <h6 className="layerNameCSS">方位角：
                                                            <button className="ts circular pulsing mini icon button" style={{fontSize:"8px"}} onClick={(e)=>this.onHelpClick("AzimuthHelp")}>
                                                                <i className="help small icon" style={{color:"#919191"}}></i>
                                                            </button>
                                                        </h6>
                                                    </div>
                                                    <div className="ts six wide column">                            
                                                        <input type="range" min="-180" max="180" defaultValue={this.state.lightAzimuth} value={this.state.lightAzimuth} step="1" style={siderRangeCSS} onMouseEnter={(e)=>this.lightMouseEnter()} onMouseLeave={(e)=>this.lightMouseLeave()} onChange={(e)=>this.setLightAzimuth(e)}></input>                             
                                                    </div>
                                                </div>
                                                <div className="ts grid">
                                                    <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                                        <h6 className="layerNameCSS">仰角：</h6>
                                                    </div>
                                                    <div className="ts six wide column"> 
                                                        <input type="range" min="1" max="180" defaultValue={this.state.lightZenith} value={this.state.lightZenith} step="1" style={siderRangeCSS} onMouseEnter={(e)=>this.lightMouseEnter()} onMouseLeave={(e)=>this.lightMouseLeave()} onChange={(e)=>this.setLightZenith(e)}></input>                             
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        
                                    </div>                                    
                                </div> : null
                        }                        
                    </div>
                </div>
            </div>            
        );        
    }
}

class TerrainDrawSetting extends React.Component{
    constructor(){
        super();
        this.state = {
            fillMode : "default",
            throughSurface : false,
            waterRipple : true,
            waterLevel : "1",
            helpMode : "None"
        }; 
    }
    fillModeChange(event){
        const fillMode = event.target.value;
        switch(fillMode){
            case "default" :
                window.main.OView.drawTerrainSetting = {
                    "grid": false,
                    "vertexWireframe": false,
                    "slopeColorSetting": { "isopen": false },
                    "aspectColorSetting": { "isopen": false },
                    "heightColorSetting": { "isopen": false },
                    "wireframeColor": "#ffffff",
                    "surface": true
                };
                break;
            case "wreframe" :
                window.main.OView.drawTerrainSetting = {
                    "grid": false,
                    "vertexWireframe": true,
                    "vertexWireframeWithBaselayer": true,
                    "slopeColorSetting": { "isopen": false },
                    "aspectColorSetting": { "isopen": false },
                    "heightColorSetting": { "isopen": false },
                    "wireframeColor": "#ffffff",
                    "surface": false
                };
                break;
            case "grid" :
                window.main.OView.drawTerrainSetting = {
                    "grid": true,
                    "vertexWireframe": false,
                    "slopeColorSetting": { "isopen": false },
                    "aspectColorSetting": { "isopen": false },
                    "heightColorSetting": { "isopen": false },
                    "wireframeColor": "#ffffff",
                    "surface": true
                };
                break;
            case "slope" :
                window.main.OView.drawTerrainSetting = {
                    "grid": false,
                    "vertexWireframe": false,
                    "slopeColorSetting": { "isopen": true },
                    "aspectColorSetting": { "isopen": false },
                    "heightColorSetting": { "isopen": false },
                    "wireframeColor": "#ffffff",
                    "surface": true
                };
                break;
            case "aspect" :
                window.main.OView.drawTerrainSetting = {
                    "grid": false,
                    "vertexWireframe": false,
                    "slopeColorSetting": { "isopen": false },
                    "aspectColorSetting": { "isopen": true },
                    "heightColorSetting": { "isopen": false },
                    "wireframeColor": "#ffffff",
                    "surface": true
                };
                break;
            case "height" :
                window.main.OView.drawTerrainSetting = {
                    "grid": false,
                    "vertexWireframe": false,
                    "slopeColorSetting": { "isopen": false },
                    "aspectColorSetting": { "isopen": false },
                    "heightColorSetting": { "isopen": true },
                    "wireframeColor": "#ffffff",
                    "surface": true
                };
                break;
        };
        this.setState({fillMode:fillMode});
    }
    setThroughSurfaceOpen(){
        window.main.OView.throughSurface = !this.state.throughSurface;
        this.setState({throughSurface : !this.state.throughSurface});
    }    
    setWaterRippleOpen(){
        window.main.OView.getTerrainOverlay('Water').show = !this.state.waterRipple;
        window.main.OView.drawTerrainSetting = { showWater: !this.state.waterRipple };        
        this.setState({waterRipple : !this.state.waterRipple});
    }
    onHelpClick(mode){
        this.setState({helpMode:mode});
    }
    waterLevelChange(event){
        const waterLevel = event.target.value;
        switch(waterLevel){
            case "0" : 
                window.main.OView.drawTerrainSetting = { waterQuality: "low"};
                break;
            case "1" :
                window.main.OView.drawTerrainSetting = { waterQuality: "normal"};
                break;
            case "2" : 
                window.main.OView.drawTerrainSetting = { waterQuality: "high"};
                break;
            case "3" :
                window.main.OView.drawTerrainSetting = { waterQuality: "very high"};
                break;
        }
        this.setState({waterLevel:waterLevel});
    }
    render(){
        switch(this.state.helpMode){
            case "fillMod":
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/zMRXiaufPSI" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help')); 
                break;
            case "ThroughSurface":
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/qr3kx9CKxgI" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help')); 
                break; 
            case "WaterRipple":
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/1bhmOSBATN4" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help')); 
                break;
            case "None":
                ReactDOM.unmountComponentAtNode(document.getElementById('Help'));
                break;
        }
        return(
            <div className="ts card" style={{margin:"10px 20px 10px 20px"}}>
                <div className="content">
                    <div className="header">地形地表設定</div>
                    <div className="description">
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">
                                    繪製模式：
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"8px"}} onClick={(e)=>this.onHelpClick("fillMod")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </h6>
                            </div>
                            <div className="ts six wide column">                            
                                <select className="ts borderless basic dropdown" onChange={(e)=>this.fillModeChange(e)} value={this.state.fillMode} style={{width:"100%"}}>
                                    <option value="default">預設</option>
                                    <option value="wreframe">框架</option>
                                    <option value="grid">框線</option>
                                    <option value="slope">坡度填色</option>
                                    <option value="aspect">坡向填色</option>
                                    <option value="height">高度填色</option>
                                </select>                                        
                            </div>
                        </div>
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">穿越地表：
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"8px"}} onClick={(e)=>this.onHelpClick("ThroughSurface")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </h6>
                            </div>
                            <div className="ts six wide column">                            
                                <div class="ts toggle checkbox">
                                    <input type="checkbox" id="ThroughSurface" checked={this.state.throughSurface} onClick={(e)=>this.setThroughSurfaceOpen()}></input>
                                    <label for="ThroughSurface" ></label>
                                </div>                              
                            </div>
                        </div> 
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">水面波紋：
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"8px"}} onClick={(e)=>this.onHelpClick("WaterRipple")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </h6>
                            </div>
                            <div className="ts six wide column">                            
                                <div class="ts toggle checkbox">
                                    <input type="checkbox" id="WaterRipple" checked={this.state.waterRipple} onClick={(e)=>this.setWaterRippleOpen()}></input>
                                    <label for="WaterRipple" ></label>
                                </div>                              
                            </div>
                        </div> 
                        {
                            this.state.waterRipple ?
                            <div className="ts grid">
                                <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                    <h6 className="layerNameCSS">波紋等級：</h6>
                                </div>
                                <div className="ts six wide column">                            
                                    <select className="ts borderless basic dropdown" onChange={(e)=>this.waterLevelChange(e)} value={this.state.waterLevel} style={{width:"100%"}}>
                                        <option value="0">低</option>
                                        <option value="1">一般</option>
                                        <option value="2">高</option>
                                        <option value="3">最高</option>
                                    </select>                                
                                </div>
                            </div> : null
                        }                  
                    </div>
                </div>
            </div>
        );
    }
}

class GlobalSettingSidebar extends React.Component{
    constructor() {
        super();
        this.sidebarSwitch = this.sidebarSwitch.bind(this);
    }
    sidebarSwitch(){
        this.props.setglobalSettingOpen();
    }
    render(){
        const isglobalSettingOpen = this.props.isglobalSettingOpen;        
        const sideMenuCSS ={
            overflow : 'inherit',
            transform : isglobalSettingOpen?'translate3d(0, 0, 0)':'translate3d(-120%, 0, 0)',
            width : '480px'
        };
        const titleCSS = {
            margin: '10px 10px 10px 10px' 
        };
        return(
            <div>
                <div className="ts left vertical sidebar visible menu" id="sideMenu" style={sideMenuCSS}>
                    <div className="ts grid">
                        <div className="row" id="sideMenuTitle">
                            <div className="fourteen wide column">
                                <h4 className="ts header" style={titleCSS}>
                                    <i className="settings icon"></i>
                                    <div className="content">
                                        圖台設定
                                    </div>
                                </h4>
                            </div>
                            <div className="two wide column" id="closeIconColumn">
                                <i className="remove icon" id="closeIcon" onClick={(e)=>this.sidebarSwitch(e)}></i>                        
                            </div>
                        </div>
                    </div>
                    <div style={{overflowY: "scroll"}}>
                        <TerrainDrawSetting />
                        <ContourLineSetting />
                        <LightSetting /> 
                        <AboutUs />                       
                    </div>                    
                </div>
            </div>            
        );
    }
}
export default GlobalSettingSidebar;